import React from "react";
import UserPopover from "./userPopover";
var NavUser = function NavUser(_ref) {
  var userNav = _ref.userNav,
    www = _ref.www,
    c = _ref.c,
    text = _ref.text;
  return /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-right-item'
  }, /*#__PURE__*/React.createElement(UserPopover, {
    userNav: userNav,
    text: text,
    www: www,
    c: c
  }));
};
export default NavUser;